/**
 * FAQ accordion fallback.
 *
 * Modern browsers implement exclusive <details> natively via the `name` attribute, so
 * one-at-a-time needs no JavaScript there. This closes the gap on browsers that do not
 * support it yet, and does nothing where the platform already handles it.
 *
 * Everything else about the accordion — opening, keyboard, screen-reader semantics — is
 * native and works with this file absent entirely.
 */
(() => {
  // Feature-detect exclusive <details>: supporting browsers expose `name` on the element.
  const NATIVE = 'name' in document.createElement('details');

  const init = (list) => {
    if (NATIVE) return;
    if (list.dataset.ebFaqSingle !== 'true') return;
    if (list.dataset.ebFaqBound === 'true') return;
    list.dataset.ebFaqBound = 'true';

    const items = Array.from(list.querySelectorAll('details'));

    for (const item of items) {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        for (const other of items) {
          if (other !== item) other.open = false;
        }
      });
    }
  };

  const boot = () => {
    for (const list of document.querySelectorAll('[data-eb-faq]')) init(list);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
